import {usePullRequestAnalyticsStore} from './PullRequestsAnalyticsStore'

export const useGetINPDiffTags = () => usePullRequestAnalyticsStore(s => s.getINPDiffTags)

export const useIsVirtualizationEnabled = () => usePullRequestAnalyticsStore(s => s.virtualizationEnabled === 'true')
